module.exports = __webpack_public_path__ + "static/media/arrowUpWhite.5104089b.svg";